import React, { useContext, useEffect, useState } from 'react';

import { Course, UserRole } from '../../types/lms.types';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { NecttosContext } from '../../../context/NecttosContext';
import { formatDate } from '../../utilities';

interface AssessmentsViewProps {
	course: Course;
	userRole: UserRole;
	selectedModule: string;
	onViewAssignment?: (assignment: any, source?: string) => void;
}

const AssessmentsView: React.FC<AssessmentsViewProps> = ({ course, userRole, selectedModule , onViewAssignment}) => {
	const [allAssesments, setAssesments] = useState<any[]>([]);
	const { collegeId } = useContext(NecttosContext)

	useEffect(() => {
		const loadData = async () => {
			const instance = await getAxiosTokenInstance();
			try {
				let resp;
				//?subjectId=subject123&collegeId=COLL-123&totalStudents=1
				if (userRole == 'teacher') {
					resp = await instance.get(`college/lms/groupAssignments/getAllAssignmentsForTeachers`, {
						params: { subjectId: course.subjectId, collegeId, totalStudents:20}
					});
					console.log(resp.data.data)
					// ?subjectId=subject123&collegeId=COLL-123&totalStudents=1&studentId=student123
				} else if (userRole == 'student') {
					resp = await instance.get(`/college/lms/groupAssignments/getAllAssignmentsForStudents`, {
						params: {
							subjectId: course.subjectId,
							collegeId,
							totalStudents: 20,
							studentId: 'NST-24CC30EF1B6F-4CA8-A416-0C79605B15DB'
						}
					});
					
				}
				 if (resp?.data) {
					console.log(resp?.data.data);
        // Check if selectedModule is not 'all'
        console.log(selectedModule)
        if (selectedModule !== 'all') {
          const filteredContent = resp.data.data.filter((content: any) => {
            // Make sure to return true or false based on the condition
            return content.moduleId == selectedModule;
          });
          setAssesments(filteredContent); // Set the filtered content
        } else {
          setAssesments(resp.data.data); // If selectedModule is 'all', show all content
        }
      }
			} catch (err) {}
		};

		loadData();
	}, [userRole, course, selectedModule]);
	// Mock assessments data combining assignments and quizzes
	// const assessments = [
	//   {
	//     id: 1,
	//     type: 'assignment',
	//     title: 'Linear Algebra Problem Set',
	//     description: 'Complete exercises 1-15 from Chapter 3. Show all working steps.',
	//     moduleId: 'mod1',
	//     dueDate: '20/1/2024',
	//     status: 'Pending',
	//     submissions: '32/45',
	//     maxMarks: 100,
	//     icon: '📝'
	//   },
	//   {
	//     id: 2,
	//     type: 'quiz',
	//     title: 'Algebra Fundamentals Quiz',
	//     description: 'Test your understanding of basic algebra concepts.',
	//     moduleId: 'mod1',
	//     dueDate: '18/1/2024',
	//     status: 'Available',
	//     maxMarks: 50,
	//     timeLimit: '30 minutes',
	//     icon: '📋'
	//   },
	//   {
	//     id: 3,
	//     type: 'assignment',
	//     title: 'Video Presentation - Mathematical Concepts',
	//     description: 'Create a 5-minute video explaining a mathematical concept of your choice.',
	//     moduleId: 'mod2',
	//     dueDate: '15/1/2024',
	//     status: 'Submitted',
	//     submissions: '45/45',
	//     maxMarks: 50,
	//     icon: '🎥'
	//   },
	//   {
	//     id: 4,
	//     type: 'quiz',
	//     title: 'Linear Equations Assessment',
	//     description: 'Comprehensive quiz on linear equations and systems.',
	//     moduleId: 'mod2',
	//     dueDate: '22/1/2024',
	//     status: 'Available',
	//     maxMarks: 75,
	//     timeLimit: '45 minutes',
	//     icon: '📋'
	//   }
	// ].filter(assessment => selectedModule === 'all' || assessment.moduleId === selectedModule);

	const getStatusBadge = (status: boolean) => {
		const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

		switch (status) {
			case false:
				return `${baseClasses} bg-yellow-100 text-yellow-800`;
			case true:
				return `${baseClasses} bg-green-100 text-green-800`;
			// case 'Available':
			// 	return `${baseClasses} bg-blue-100 text-blue-800`;
			// case 'Graded':
			// 	return `${baseClasses} bg-purple-100 text-purple-800`;
			default:
				return `${baseClasses} bg-gray-100 text-gray-800`;
		}
	};

	// const handleViewDetails = () => {
    //  onViewAssignment()
	// }
type ContentType = 'quiz' | 'assignment' ;
const icons: Record<ContentType, string> = {
  quiz: '📝',
  assignment: '📚',
  
};

	const getActionButton = (assessment: any) => {
		if (userRole === 'student') {
			switch (assessment.status) {
				case 'Available':
					return assessment.type === 'quiz' ? 'Start Quiz' : 'Submit Assignment';
				case 'Submitted':
					return 'View Submission';
				case 'Graded':
					return 'View Grade';
				default:
					return 'View Details';
			}
		} else {
			return assessment.type === 'quiz' ? 'Manage Quiz' : 'View Submissions';
		}
	};

	return (
		<div className='p-6 space-y-6'>
			<div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4'>
				<h2 className='text-xl font-semibold'>Assessments</h2>
				<div className='flex items-center gap-4 text-sm text-gray-500'>
					<span>{allAssesments?.filter((a: any) => a.type === 'assignment').length} Assignments</span>
					<span>{allAssesments?.filter((a: any) => a.type === 'quiz').length} Quizzes</span>
				</div>
			</div>

			<div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
				{allAssesments?.map((assessment: any) => (
					<div key={`${assessment.type}-${assessment._id}`} className='bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 overflow-hidden hover:shadow-md transition-shadow'>
						<div className='p-6'>
							<div className='flex items-start justify-between mb-4'>
								<div className='flex items-center gap-3'>
									<span className='text-2xl'>{icons[assessment.type as ContentType]}</span>
									<div>
										<span className='text-xs uppercase tracking-wider text-gray-500 font-medium'>{assessment.type}</span>
										<h3 className='text-lg font-medium text-gray-900 dark:text-white'>{assessment.title}</h3>
									</div>
								</div>
								<span className={getStatusBadge(assessment.isSubmitted)}>{assessment.isSubmitted?'Submitted': 'Pending'}</span>
							</div>

							<p className='text-gray-600 dark:text-gray-400 mb-4 text-sm'>{assessment.description}</p>

							<div className='space-y-2 mb-4'>
								<div className='flex justify-between text-sm'>
									<span className='text-gray-500'>Due Date:</span>
									{assessment.type == 'assignment' &&( <span className='font-medium'>{formatDate(assessment.dueDate)}</span>)}
									{assessment.type == 'quiz' && (<span className='font-medium'>{formatDate(assessment.endDate)}</span>)}
								</div>
								<div className='flex justify-between text-sm'>
									<span className='text-gray-500'>Max Marks:</span>
									<span className='font-medium'>{assessment.maxMark}</span>
								</div>
								{assessment.submissions && (
									<div className='flex justify-between text-sm'>
										<span className='text-gray-500'>Submissions:</span>
										<span className='font-medium'>{assessment.submissionCount}</span>
									</div>
								)}
								{assessment.timeLimit && (
									<div className='flex justify-between text-sm'>
										<span className='text-gray-500'>Time Limit:</span>
										<span className='font-medium'>{assessment.timeLimit}{assessment.timeLimitUnit}</span>
									</div>
								)}
							</div>

							<div className='flex justify-end'>
								<button className='inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'  onClick={() => onViewAssignment?.(assessment, 'course')}>{getActionButton(assessment)}</button>
							</div>
						</div>
					</div>
				))}
			</div>
			{allAssesments.length === 0 && (
        <div className="text-center py-12">
          <span className="text-6xl mb-4 block">-</span>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No assessments found
          </h3>
          <p className="text-gray-500">
            No assessments available for the selected module.
          </p>
        </div>
      )}
		</div>
	);
};

export default AssessmentsView;
